import React, { useState, useEffect } from "react";
import { makeStyles, Box, Button, Container } from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import Toolbar from "./Toolbar";
import {
  apiEndpoints,
  apiGetByIdRequest,
  apiPutRequest,
  apiPostRequest,
} from "src/utils/api/api";
import { addCreatedUpdatedPublishedArchivedFields } from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import ArchiveIcon from "@material-ui/icons/Archive";
import SearchIcon from "@material-ui/icons/Search";
import { NavLink as RouterLink } from "react-router-dom";
import EmailIcon from "@material-ui/icons/Email";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const RowButtons = (row, customHandlers, ...rest) => {
  return (
    <Box>
      <Tooltip title="Archiwizuj">
        <IconButton
          aria-label="opublikuj"
          onClick={() => customHandlers.archiveHandler(row)}
        >
          <ArchiveIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Podgląd">
        <IconButton
          aria-label="podgląd"
          component={RouterLink}
          to={`/aktualnosci/podglad/${row.id}`}
        >
          <SearchIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Edytuj">
        <IconButton
          aria-label="edytuj"
          onClick={() => customHandlers.editHandler(row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Newsletter">
        <IconButton
          aria-label="Newsletter"
          component={RouterLink}
          to={`/powiadomienieaktualnosci/${row.id}`}
        >
          <EmailIcon />
        </IconButton>
      </Tooltip>
      {!row.firstElement && customHandlers.isPositionSortDown ? (
        <Tooltip title="Przesuń w górę">
          <IconButton
            aria-label="Przesuń w górę"
            onClick={() => customHandlers.positionUpHandler(row)}
          >
            <ArrowUpwardIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
      {!row.lastElement && customHandlers.isPositionSortDown ? (
        <Tooltip title="Przesuń w dół">
          <IconButton
            aria-label="Przesuń w dół"
            onClick={() => customHandlers.positionDownHandler(row)}
          >
            <ArrowDownwardIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
    </Box>
  );
};

const PublishedView = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
}) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [dialogArchiveOpen, setDialogArchiveOpen] = useState(false);
  const [archivedNews, setArchivedNews] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [sortColumn, setSortColumn] = useState("artPosition_desc");

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getNewsByStatusKey.path, "published", true)
      .then((data) => {
        disableGlobalLoader();
        setRows(
          addCreatedUpdatedPublishedArchivedFields(
            data,
            "createdBy",
            "createdAt",
            "updatedBy",
            "updatedAt",
            "publishedBy",
            "publishedAt",
            ", "
          )
        );
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        }
      });
    return () => {};
  }, [reloadCounter]);

  const archiveHandler = (row) => {
    setArchivedNews(row);
    handleClickArchiveOpen(row);
  };

  const editHandler = (row) => {
    apiPostRequest(
      apiEndpoints.copyNewsAsDraft.path,
      {
        id: row.id,
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        navigate(`/aktualnosci/edytujart/${data.id}`);
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        }
      });
  };

  const positionUpHandler = (row) => {
    apiPutRequest(
      apiEndpoints.setPublishedNewsPositionUp.path,
      {
        id: row.id,
      },
      true
    )
      .then(() => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        }
      });
  };

  const positionDownHandler = (row) => {
    apiPutRequest(
      apiEndpoints.setPublishedNewsPositionDown.path,
      {
        id: row.id,
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        }
      });
  };

  const headCells = [
    {
      id: "title",
      numeric: false,
      disablePadding: true,
      fieldName: "title",
      sortable: true,
      main: true,
      label: "Tytuł",
    },
    {
      id: "created",
      fieldName: "createdAt",
      fieldName2: "createdBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto utworzył",
    },
    {
      id: "updated",
      fieldName: "updatedAt",
      fieldName2: "updatedBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto zmodyfikował",
    },
    {
      id: "published",
      fieldName: "publishedAt",
      fieldName2: "publishedBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto opublikował",
    },
    {
      id: "artPosition",
      numeric: false,
      disablePadding: true,
      fieldName: "artPosition",
      sortable: true,
      main: false,
      label: "Pozycja na liście",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      customHandlers: {
        archiveHandler,
        editHandler,
        positionDownHandler,
        positionUpHandler,
        isPositionSortDown: sortColumn === "artPosition_desc",
      },
      component: RowButtons,
    },
  ];

  const handleClickArchiveOpen = () => {
    setDialogArchiveOpen(true);
  };

  const handleArchiveDialogClose = () => {
    setDialogArchiveOpen(false);
  };

  const handleArchive = () => {
    enableGlobalLoader();
    setDialogArchiveOpen(false);

    if (archivedNews) {
      apiPutRequest(
        apiEndpoints.setNewsArchivedStatus.path,
        {
          id: archivedNews.id,
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          setReloadCounter(reloadCounter + 1);
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    }
  };

  return (
    <Page className={classes.root} title="Aktualności - opublikowane">
      <Container maxWidth={false}>
        <KmFilteredTable
          markable={false}
          headCells={headCells}
          rows={rows}
          defaultOrderBy="artPosition"
          setSortColumn={setSortColumn}
        />
        <Dialog
          fullScreen={fullScreen}
          open={dialogArchiveOpen}
          onClose={handleArchiveDialogClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {"Archiwizacja artykułów"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Czy na pewno chcesz zarchiwizować artykuł "
              {archivedNews ? archivedNews.title : "-"}"?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={handleArchiveDialogClose}
              color="primary"
            >
              Nie
            </Button>
            <Button onClick={handleArchive} color="primary" autoFocus>
              Tak
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(PublishedView);
